import RailStatusOut from './RailStatusOut';

export default RailStatusOut;
